import BWDataService from './bw-data.service';
import UrlHelper from 'src/utils/url.helper';

export default class LogoutService {
    public static handleLogoutRedirect(): void {
        BWDataService.clearUser();
        if (process.env.REACT_APP_ALLOW_TEST_LOGIN) {
            UrlHelper.replacePath('/login');
        } else {
            const location = window.location.href;
            const locale = navigator.language;
            const host = process.env.REACT_APP_ONE_LOGIN_HOST;
            window.location.assign(host + '/' + locale + '/account/login?target=' + encodeURIComponent(location));
        }
    }
}
